import axios from "axios";
import React, { useState, useEffect } from "react";
import MultiCreatableSelect from "../inventory/MultiCreatableSelect";

function Contractors({ selectedContractors, onContractorsChange }) {
  const [data, setData] = useState([]);
  const [name, setName] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "user/contractors-list")
      .then((res) => {
        setData(res.data.users);
      });
  }, []);

  const options = data.map((item) => ({
    value: item._id,
    label: item.firstName,
  }));

  // const selectedContractorNames = selectedContractors.map((contractorId) => {
  //   const contractor = data.find((item) => item._id === contractorId);
  //   return contractor ? contractor.firstName : '';
  // });

  console.log("selectedContractors", selectedContractors);

  return (
    <div className="App">
      <label className="form-label" htmlFor="variantName">
        Select Expert Contractors
      </label>
      <MultiCreatableSelect
        onChange={onContractorsChange}
        options={options}
        // value={selectedContractors.map((item) => ({ label: item.firstName, value: item._id }))}
      />
    </div>
  );
}

export default Contractors;
